import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import type { Resolver } from 'react-hook-form';

const schema = z.object({
  app: z
    .string()
    .optional()
    .refine((val) => val && val.length > 0, {
      message: 'App is required',
    }),
  flow_id: z
    .union([z.string(), z.number()])
    .optional()
    .refine((val) => val !== undefined && !!val, {
      message: 'Flow ID is required',
    }),
  ad_account_id: z
    .string()
    .optional()
    .refine((val) => val && val.length > 0, {
      message: 'Account ID is required',
    }),
});
export default {
  schema,
  resolver: zodResolver(schema),
} as {
  schema: typeof schema;
  resolver: Resolver<z.infer<typeof schema>>;
};
